// ** Third Party Components
import TimeAgo from "javascript-time-ago"
import { useTranslation } from 'react-i18next'
import ReactCountryFlag from 'react-country-flag'
import { useDispatch } from 'react-redux'

// ** Reactstrap Imports
import { UncontrolledDropdown, DropdownMenu, DropdownItem, DropdownToggle } from 'reactstrap'

import useJwt from "../../../../auth/jwt/useJwt"
import { isUserLoggedIn } from '@utils'
import { handleChangeUserData } from '../../../../redux/authentication'
import {updateTypes} from "../../../../redux/types"
import { getUserData } from '../../../../utility/Utils'
import { useHistory } from 'react-router-dom'

const IntlDropdown = () => {
  // ** Hooks
  const { i18n } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()

  let language

  if (i18n.language) {
    if (i18n.language.includes("-")) {
      language = i18n.language.split("-")[0]
    } else {
      language = i18n.language
    }
  } else {
    language = "pl"
  }

  // ** Function to switch Language
  const handleLangUpdate = (e, lang) => {
    e.preventDefault()
    if (isUserLoggedIn() !== null) {
      useJwt.changeLanguage(lang).then(response => {
        const user = getUserData()
        user.user = response.data.data
        dispatch(handleChangeUserData(user))
        dispatch(updateTypes())
      })
    } else {
      dispatch(updateTypes(lang))
    }
    
    i18n.changeLanguage(lang)
    history.push()
  }

  return (
    <UncontrolledDropdown href='/' tag='li' className='dropdown-language nav-item'>
      <DropdownToggle href='/' tag='a' className='nav-link' onClick={e => e.preventDefault()}>
        <ReactCountryFlag
          svg
          className='country-flag flag-icon'
          countryCode={language === 'en' ? 'gb' : language === 'sr' ? 'rs' : language}
        />
      </DropdownToggle>
      <DropdownMenu className='mt-0' end>
        <DropdownItem href='/' tag='a' onClick={e => handleLangUpdate(e, 'pl')}>
          <ReactCountryFlag className='country-flag' countryCode='pl' svg />
          <span className='ms-1'>Polski</span>
        </DropdownItem>
        <DropdownItem href='/' tag='a' onClick={e => handleLangUpdate(e, 'en')}>
          <ReactCountryFlag className='country-flag' countryCode='gb' svg />
          <span className='ms-1'>English</span>
        </DropdownItem>
        <DropdownItem href='/' tag='a' onClick={e => handleLangUpdate(e, 'es')}>
          <ReactCountryFlag className='country-flag' countryCode='es' svg />
          <span className='ms-1'>Español</span>
        </DropdownItem>
        <DropdownItem href='/' tag='a' onClick={e => handleLangUpdate(e, 'sr')}>
          <ReactCountryFlag className='country-flag' countryCode='rs' svg />
          <span className='ms-1'>Serbian</span>
        </DropdownItem>

      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default IntlDropdown
